import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import { getNameInitials } from 'utils/formatText'
import MdxEditor from 'components/atoms/input/MdxEditor'
import { BlankNotesItem } from 'components/atoms/BlankEventItem'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { MuiMarkdown } from 'mui-markdown'

const LiveNote = ({
  connection,
  notes,
  handleUpdateNotes = () => {},
  isClosed,
  isPrivateNote = false,
  showPreview = false
}) => {
  const { t } = useTranslation()
  const name = connection?.firstName || getNameInitials(connection)
  const [noteValue, setNotesValue] = useState(notes.current)
  const [editorRef, setEditorRef] = useState(null)

  const handleNoteUpdate = value => {
    setNotesValue(value)
    notes.current = value
    handleUpdateNotes(value)
  }

  useEffect(() => {
    if (notes.current !== noteValue) {
      setNotesValue(notes.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notes.current])

  const cleanMarkdown = md => {
    const cleanMd = md
      .replace(/&#x20;|\u00A0/g, '&nbsp;')
      .replace(/&#x9;|\t/g, '&nbsp;')
      .trim()
    return cleanMd
  }

  return (
    <Box
      sx={{
        backgroundColor: colors.White,
        width: '100%',
        height: isPrivateNote ? '100%' : !showPreview ? '50%' : '40%',
        overflowY: 'auto',
        position: 'relative',
        cursor: !showPreview ? 'text' : 'default'
      }}
      onClick={() => {
        editorRef?.focus()
      }}>
      {!showPreview ? (
        <>
          <MdxEditor
            value={noteValue}
            changeCallback={value => {
              handleNoteUpdate(value)
            }}
            readOnly={isClosed}
            placeholder={
              isPrivateNote
                ? t('myTeam.anythingYouTypeHere')
                : t('myTeam.canAddAgenda')
            }
            hideCopy={isPrivateNote}
            removePlaceholderPaddingX={!isPrivateNote}
            setEditorRef={setEditorRef}
          />
          {!isPrivateNote && noteValue === '' && (
            <BlankNotesItem containerSx={{ position: 'absolute', top: 100 }} />
          )}
        </>
      ) : (
        <InCardStack
          spacing={8}
          alignItems={'flex-start'}
          sx={{
            '& ul li': {
              wordBreak: 'break-word'
            },
            '& li:has(input[type="checkbox"])::marker': {
              content: '""'
            }
          }}>
          <RowStack spacing={2}>
            <LockOutlinedIcon sx={{ fontSize: 20, color: colors.Grey250 }} />
            <Typography
              variant='body1KindaSmall'
              color={colors.Grey250}
              width='100%'>
              {t('myTeam.connectionAgendaItems', {
                firstName: name
              })}
            </Typography>
          </RowStack>
          {noteValue ? (
            <MuiMarkdown>{cleanMarkdown(noteValue)}</MuiMarkdown>
          ) : (
            <BlankNotesItem />
          )}
        </InCardStack>
      )}
    </Box>
  )
}

export default LiveNote
